/** @format */

import styled from "styled-components";
import { colors, fonts, mixins } from "../../../../css/variables";
import { FlexBox } from "../../../layouts/FlexBox";
import { FormWrap } from "../../../layouts/FormWrap";
import { Checkbox, Button, AnotherTabLink } from "../../../ui-parts";
import useEconomicEstimateElementHooks from "../../../../hooks/useEconomicEstimateElementHooks";
import useNavigateByAgent from "../../../../hooks/useNavigateByAgentHooks";
import EconomicEstimateTable from "../../../ui-parts/emochi/EconomicEstimate/EconomicEstimateTable";
import { initApiModelType, entryInfoPostResponseDataType } from "../../../../constance/typeModel";
import { ErrorHandler } from "../../../../api/ErrorHandler";

const BlueWraper = styled.div`
  background-color: ${colors.themeColor("background_whitegray")};
  border: solid 1px ${colors.themeColor("border_box")};
  border-radius: 8px;
  padding: 20px;
`;

const UL = styled.ul`
  list-style: inherit;
  padding-left: 20px;
  li {
    font-size: ${fonts.fontSizeRem("ms")};
    ${mixins.screenUnder()} {
      font-size: ${fonts.fontSizeRem("xs")};
    }
  }
`;

const EmochiEconomicEstimateElement = ({ redirect }: { redirect?: boolean }) => {
  const { navigateByAgent } = useNavigateByAgent();
  const {
    feeArray,
    EconomicInfoData,
    sumFeeInfoData,
    vacantCheckState,
    creditPaymentSiteFeeState,
    setCheckBoxStateHandler,
    navigateBack,
    normal,
    abnormal,
    entryEconomicData,
    economicConditionMasterInfoData,
  } = useEconomicEstimateElementHooks(navigateByAgent, redirect);

  const { ErrorHandle } = ErrorHandler(navigateByAgent);

  //経済条件画面のエラーハンドラー
  const navigateEntryMerchantHandler = async () => {
    const response = await entryEconomicData();
    //チェックボックスバリデーションに引っかかった時はリターン
    if (response === null) return;
    ErrorHandle<initApiModelType<entryInfoPostResponseDataType>>(response, normal, abnormal, false);
  };

  return (
    <FormWrap width={700} padding={36}>
      <h1 className="mt0">ご利用料金</h1>
      <p>ご利用料金は以下の通りです。</p>
      <h2 className="mt40 mb20">クレジットカード決済</h2>
      <EconomicEstimateTable
        contentName={"credit"}
        sumSystemCost={sumFeeInfoData.credit}
        options={feeArray.credit}
        salesHandleFee
        paymentSiteFee={creditPaymentSiteFeeState}
        page={"economic_estimate"}
      />
      {EconomicInfoData.atobarai.system_setting.select_flag && (
        <>
          <h2 className="mt40 mb20">コンビニあと払い</h2>
          <EconomicEstimateTable
            contentName={"atobarai"}
            settlementFee={economicConditionMasterInfoData.atobarai.fee}
            businessOperatorFee={economicConditionMasterInfoData.atobarai.business_operator_fee}
            sumSystemCost={sumFeeInfoData.atobarai}
            options={feeArray.atobarai}
            salesHandleFee
            paymentSiteFee={0}
            page={"economic_estimate"}
          />
        </>
      )}
      <UL>
        <li>上記料金は「あと払いの決済手数料」を除きすべて税別表記となります。</li>
        <li>振込手数料はゼウス負担となります。</li>
        <li>支払日が金融機関休業日の場合、前営業日の支払いとさせていただきます。</li>
        <li>取引手数料及びオプションサービス利用料は、各月の売上金から相殺となります。</li>
      </UL>
      <h2 className="mt40 mb20">お申し込みの前にご確認ください</h2>
      <BlueWraper>
        <FlexBox column gap={4} mt={0}>
          <AnotherTabLink href={"https://www.cardservice.co.jp/guide/preparation.html#anchor-08"}>
            取扱不可商材について
          </AnotherTabLink>
          {EconomicInfoData.cvs.system_setting.select_flag && (
            <AnotherTabLink href={"https://www.cardservice.co.jp/guide/cvs.html"}>
              コンビニサービス導入基準
            </AnotherTabLink>
          )}
        </FlexBox>
      </BlueWraper>
      <h2 className="mt40 mb0">規約等のご確認と同意</h2>
      <p className="font-ms mt16">お申し込みには各種利用規約等への同意が必要です。</p>
      <BlueWraper>
        <FlexBox column gap={4} mt={0}>
          <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_privacy.pdf"}>
            個人情報の取扱いについて
          </AnotherTabLink>
          <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_kyotsu.pdf"}>
            ゼウス決済サービス共通規約
          </AnotherTabLink>
          {EconomicInfoData.credit.system_setting.select_flag && (
            <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_creditcard.pdf"}>
              クレジット決済サービス利用規約（包括加盟型 ）
            </AnotherTabLink>
          )}
          {EconomicInfoData.atobarai.system_setting.select_flag && (
            <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_atobarai.pdf"}>
              後払い決済サービス加盟店規約・後払い決済サービス利用規約
            </AnotherTabLink>
          )}
        </FlexBox>
        <FlexBox column gap={4} mt={30}>
          <Checkbox
            id="agreement"
            label={"規約等へ同意します"}
            onChange={setCheckBoxStateHandler}
            iserror={vacantCheckState.agreement_msg}
          />
          <Checkbox
            id="charges_check"
            label="ご利用料金について確認しました"
            onChange={setCheckBoxStateHandler}
            iserror={vacantCheckState.charges_check_msg}
          />
        </FlexBox>
      </BlueWraper>
      <FlexBox mt={24} gap={16}>
        <Button variant="secoundary" onClick={navigateBack}>
          戻る
        </Button>
        <Button onClick={navigateEntryMerchantHandler}>申し込み情報入力に進む</Button>
      </FlexBox>
    </FormWrap>
  );
};

export default EmochiEconomicEstimateElement;
